export const LOAD_CATEGORIES = "LOAD_CATEGORIES";
export const LOAD_BREEDS = "LOAD_BREEDS";
export const LOAD_GENETICS = "LOAD_GENETICS";
export const SET_LOADING = "SET_LOADING";
export const LOAD_SUB_BREEDS = "LOAD_SUB_BREEDS";
export const LOAD_GENETICS_SUB_BREEDS = "LOAD_GENETICS_SUB_BREEDS";
export const ERROR_LOADING_CATEGORIES = "ERROR_LOADING_CATEGORIES";
